import {
  GUEST_ENGAGEMENT_TRUSTPILOT_USPS_BANNER,
  OPTIMIZELY_VARIANT_KEYS,
} from '../../../constants'
import { useSpecificOptimizelyUserDecision } from '../optimizely-for-client'

export function useTrustpilotUspsBannerVisible(): {
  showUsps: boolean
  uspsVariant: string | undefined
} {
  const decisionObj = useSpecificOptimizelyUserDecision(
    GUEST_ENGAGEMENT_TRUSTPILOT_USPS_BANNER,
    true,
  )
  const variantsMap = {
    [OPTIMIZELY_VARIANT_KEYS.TRUSTPILOT_USPS_VISIBLE_VARIANT_A]: 'variant_a',
    [OPTIMIZELY_VARIANT_KEYS.TRUSTPILOT_USPS_VISIBLE_VARIANT_B]: 'variant_b',
  }
  const uspsBannerEnabled = [
    OPTIMIZELY_VARIANT_KEYS.TRUSTPILOT_USPS_VISIBLE,
    OPTIMIZELY_VARIANT_KEYS.TRUSTPILOT_USPS_VISIBLE_VARIANT_A,
    OPTIMIZELY_VARIANT_KEYS.TRUSTPILOT_USPS_VISIBLE_VARIANT_B,
  ].includes(decisionObj?.variationKey)

  const decision = {
    showUsps: uspsBannerEnabled,
    uspsVariant: uspsBannerEnabled
      ? variantsMap[decisionObj?.variationKey]
      : undefined,
  }

  return decision
}
